import React, { useState } from "react"
const Contact =() =>{

    const [data,setData] = useState({
        fullname:'',
        phone:'',
        email:'',
        massage:'',
    });

    const InputEvent = (event) =>{
         const {name,value} = event.target;
         setData((perVal) =>{
             return{
                 ...perVal,
                 [name] : value,
             };
         });
    };

    const formSubmit = (e) =>{
        e.preventDefault();
        alert(`My Name is ${data.fullname}, My Mobile Number is ${data.phone}, My email is ${data.email} and Here is My massage ${data.massage}`)
    };
    return(
        <>
            <div className="my-5"> 
                <h1 className='text-center'>Contact US</h1>
            </div>
            <div className="container contact_div">
                <div className="row">
                    <div className="col-md-6 col-10 mx-auto">
                        <form onSubmit={formSubmit}>                
                            <div className="mb-3">
                                <label form="exampleFormControlInput1">Full Name</label>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    id="exampleFormControlInput1" 
                                    name="fullname"
                                    value={data.fullname}
                                    onChange={InputEvent}
                                    placeholder="Enter Your name "/>
                            </div>
                            <div className="form-group">
                                <label form="exampleFormControlInput1">Phone</label>
                                <input 
                                    type="number" 
                                    className="form-control" 
                                    id="exampleFormControlInput1" 
                                    name="phone"
                                    value={data.phone}
                                    onChange={InputEvent}
                                    placeholder="Enter Your Phone Number"/>
                            </div>
                            <div className="form-group">
                                <label form="exampleFormControlInput1">Email address</label>
                                <input 
                                    type="email" 
                                    className="form-control" 
                                    id="exampleFormControlInput1" 
                                    name="email"
                                    value={data.email}
                                    onChange={InputEvent}
                                    placeholder="name@example.com"/>
                            </div>
                            
                            <div className="form-group">
                                <label form="exampleFormControlTextarea1">Massage</label>
                                <textarea 
                                    className="form-control" id="exampleFormControlTextarea1" rows="3" 
                                    name="massage"
                                    value={data.massage}
                                    onChange={InputEvent}></textarea>
                            </div>
                            <div className="col-12 my-3">
                                <button type="submit" className="btn btn-outline-primary">Send Massage</button>
                            </div>
                        
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Contact;